import './index.scss';

import { useTrans } from 'core/hooks';
import { useSelector } from 'react-redux';
import { AppState } from 'core/redux/reducers';
import { selectCountFilteredProducts } from 'core/redux/features/products/reducers/products';
import { selectActiveProductType } from 'core/redux/features/products/reducers/productTypes';
import React from 'react';
import cls from 'classnames';

interface IResultCounterProps extends React.ComponentProps<'div'> {}

export const ResultCounter = ({ className, ...props }: IResultCounterProps) => {
  const trans = useTrans();

  const { totals, productType } = useSelector((state: AppState) => ({
    totals: selectCountFilteredProducts(state),
    productType: selectActiveProductType(state),
  }));

  return (
    <div className={cls('filter-head', className)} {...props}>
      <div className="filter-head__title">
        <span
          dangerouslySetInnerHTML={{
            __html:
              trans('total_filtered', {
                productType: `<span>${productType.label}</span>`,
              }) + ': ',
          }}
        />
        <span>
          <span className="has-text-danger"> {totals[0]}</span>/{totals[1]}
        </span>
      </div>
    </div>
  );
};
